import React from 'react';
import Axios from 'axios';
import Autosuggest from 'react-autosuggest';
import moment from 'moment';

// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_Special_Characters
// ARROW FUNCTION TUTORIAL HERE

// const escapeRegexCharacters = function(str) { return (str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))};
// const escapeRegexCharacters = str => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// REF: https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript?utm_medium=organic&utm_source=google_rich_qa&utm_campaign=google_rich_qa
// const accentsTidy = function(s) {
// 	var r = s.toLowerCase();
// 	r = r.replace(new RegExp("\\s", 'g'),"");
// 	r = r.replace(new RegExp("[àáâãäå]", 'g'),"a");
// 	r = r.replace(new RegExp("æ", 'g'),"ae");
// 	r = r.replace(new RegExp("ç", 'g'),"c");
// 	r = r.replace(new RegExp("[èéêë]", 'g'),"e");
// 	r = r.replace(new RegExp("[ìíîï]", 'g'),"i");
// 	r = r.replace(new RegExp("ñ", 'g'),"n");                            
// 	r = r.replace(new RegExp("[òóôõö]", 'g'),"o");
// 	r = r.replace(new RegExp("œ", 'g'),"oe");
// 	r = r.replace(new RegExp("[ùúûü]", 'g'),"u");
// 	r = r.replace(new RegExp("[ýÿ]", 'g'),"y");
// 	r = r.replace(new RegExp("\\W", 'g'),"");
// 	return r;
// };

class AutoSuggestPlayer extends React.Component {

  _isMounted = false;

  constructor(props) {
		super(props);

		this.state = {
			value: '',
			suggestions: [],
			players: []
		};
	
		this.onChange = this.onChange.bind(this);
		this.onBlur = this.onBlur.bind(this);
		this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
		this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
		this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
	}

	componentDidMount() {
		//console.log('AutoSuggestPlayer: componentDidMount');
		this._isMounted = true;
		var playerId = this.props.playerId;
		this.loadData(playerId);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		//console.log('AutoSuggestPlayer: UNSAFE_componentWillReceiveProps');
		var playerId = nextProps.playerId;
		this.loadData(playerId);
	}

	componentWillUnmount() {
		//console.log('AutoSuggestPlayer: componentWillUnmount');
		this._isMounted = false;
	}

	loadData(playerId) {
		//console.log('AutoSuggestPlayer - loadData');
		//console.log('this.props.option: ', this.props.option, typeof this.props.option)

		var _this = this;

		//Axios.get('/api/players/fullnamesExtra').then(function (responsePlayers) {
		this.getDataFromDB(this.props.option, function(responsePlayers) {

			var players = responsePlayers.data;

			//console.log('players');
			//console.log(players);

			var fullname = '';
			for (var idx = 0; idx < players.length; idx++) {
				if(players[idx]._id === playerId) {
					fullname = players[idx].fullname; 
				}
			}

			if (_this._isMounted) {
				_this.setState({
					players: responsePlayers.data,
					value: fullname
				});
			}
		});		
	}

	getDataFromDB(option, callback) {
		if (option === "1") {
			Axios.get('/api/players/fullnamesExtra').then(function (responsePlayers) {
				callback(responsePlayers);
			});
		} else {
			Axios.get('/api/players/fullnames').then(function (responsePlayers) {
				callback(responsePlayers);
			});			
		}
	}

	getSuggestions(value) {
		//console.log('getSuggestions');
		var suggestions = [];
		var players = this.state.players;

		// const escapedValue = escapeRegexCharacters(value.trim());
		const trimValue = value.trim();
		if (trimValue.length < 3) {
			return [
				{ notEnoughChar: true }
			];
		}
/*
		//const regex = new RegExp(accentsTidy(trimValue), 'i');
		let regex = new RegExp(trimValue.normalize('NFD').replace(/[\u0300-\u036f]/g, ""), 'i');
		//suggestions = players.filter(player => regex.test(accentsTidy(player.fullname)));
		suggestions = players.filter(player => regex.test(player.fullname.normalize('NFD').replace(/[\u0300-\u036f]/g, "")));
*/
		// v2.0 by Statelo
		var filtPlayersArray = trimValue.split(' ');
		
		// filter players with filter seek strings
		for (var playerIdx = 0; playerIdx < players.length; playerIdx++) {

			var player = players[playerIdx];
			var includeThisPlayer = true;

			// get lowercase normalized no-accend player fullname
			var playerFullnameNorm = player.fullname.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

			// filter player name with different parts
			filtPlayersArray.forEach(function (filtPlayerItem) {

				// get lowercase normalized no-accend player fullname
				var filtPlayerNorm = filtPlayerItem.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

				// Any item not found (-1) will result in final false
				if (playerFullnameNorm.indexOf(filtPlayerNorm) === -1) {
	    		includeThisPlayer = false;
				}
			})

			// Filter function result
			if (includeThisPlayer) {
				suggestions.push(player);
			}
		}

		if (suggestions.length === 0) {
			return [
				{ noData: true }
			];
		}

		return suggestions;
	}

	onChange(event, { newValue, method }) {
		//console.log('AutoSuggestPlayer: onChange');
		this.setState({
			value: newValue
		});
	}

	getSuggestionValue(suggestion) {
		// console.log('getSuggestionValue');
		if (suggestion.noData) {
			return this.state.value;
		}
		if (suggestion.notEnoughChar) {
			return this.state.value;
		}    
		return suggestion.fullname;
	}

	renderSuggestion(suggestion) {
		//console.log('renderSuggestion');
		if (suggestion.noData) {
			return (
				<span><i>Aucun joueur</i></span>
			);
		}
		if (suggestion.notEnoughChar) {
			return (
				<span><i>Entrer un minimum de 3 caractères</i></span>
			);
		}
		return suggestion.fullname;
	}
	
	onSuggestionsFetchRequested( {value} ) {
		//console.log('AutoSuggestPlayer: onSuggestionsFetchRequested');
		this.setState({
			suggestions: this.getSuggestions(value)
		});
	}

	onSuggestionsClearRequested() {
		//console.log('AutoSuggestPlayer: onSuggestionsClearRequested');
		this.setState({
			suggestions: []
		});
	}

	onSuggestionSelected(event, { suggestion }) {
		//console.log('onSuggestionSelected');
		if (!suggestion.noData && !suggestion.notEnoughChar) {
			//console.log('SELECTED: ' + suggestion.fullname + ' - ' + suggestion._id);
			this.props.dataChange(suggestion._id, suggestion.fullname);
		}
	}

	onBlur(event) {
		// not always defined
		if(this.props.onBlur) {
			this.props.onBlur(event.target.value);
		}
	}

	render() {
		//console.log('AutoSuggest: render');
		//console.log('this.state.value: ' + this.state.value);
		//console.log('this.state.suggestions.length: ' + this.state.suggestions.length);
		const value = this.state.value;
		const suggestions = this.state.suggestions;

		const inputProps = {
			placeholder: "rechercher un joueur",
			value,
			onChange: this.onChange,
			onBlur: this.onBlur,
		};

		return (
			<Autosuggest 
				suggestions = {suggestions}
				onSuggestionsFetchRequested = {this.onSuggestionsFetchRequested}
				onSuggestionsClearRequested = {this.onSuggestionsClearRequested}
				getSuggestionValue = {this.getSuggestionValue}
				renderSuggestion = {this.renderSuggestion}
				onSuggestionSelected = {this.onSuggestionSelected}
				inputProps = {inputProps}
				theme = {this.props.theme}
			/>
		);
	}

}

export default AutoSuggestPlayer;
